import { useCallback, useState } from 'react';
import { isPhoneValid } from './isPhoneValid';
import { formatPhoneNumber } from './formatPhoneNumber';
import { IBaseQuestionProps } from '../../FormContainer/types/internal';
import { path } from 'ramda';

export const usePhoneValue = (props: IBaseQuestionProps) => {
  const {
    answersState,
    question: { answerField },
    setAnswer,
    setNextStep,
  } = props;

  const [value, setValue] = useState(() => {
    const formValue = path<string>([answerField, 'value'], answersState);

    return formValue ? formatPhoneNumber(formValue) : '';
  });

  const [isValid, setIsValid] = useState(isPhoneValid(value));

  const onChange = useCallback(newValue => {
    const formatted = formatPhoneNumber(newValue);
    setValue(formatted);
    setIsValid(isPhoneValid(formatted));
  }, []);

  const onSubmit = useCallback(
    (value: string) => {
      const answer = { answerField, value };

      setAnswer(answer);
      setNextStep({
        ...answersState,
        [answerField]: answer,
      });
    },
    [setNextStep, setAnswer, answersState, answerField],
  );

  return {
    value,
    isValid,
    onChange,
    onSubmit,
  };
};
